const route = {
	name: 'products',
	path: '/products',
	redirect: '/products/list',
	component: () => import('@/components/products/products'),
	children: [
		{
			name: 'list-of-products',
			path: 'list',
			meta: {
				title: 'PRODUCTOS',
			},
			component: () => import('@/components/products/list-of-products'),
		},
		{
			name: 'products-movement',
			path: 'movement',
			meta: {
				title: 'MODIFICAR STOCK',
			},
			component: () => import('@/components/products/movement'),
		},
		{
			name: 'massive-upload',
			path: 'massive-upload',
			meta: {
				title: 'PRODUCTOS CARGA MASIVA',
			},
			component: () => import('@/components/products/list-of-massive-upload'),
		},
		{
			name: 'new-massive-upload',
			path: 'new-massive-upload',
			meta: {
				title: 'PRODUCTOS CARGA MASIVA',
			},
			component: () => import('@/components/products/massive-upload'),
		},
		{
			name: 'edit-massive-upload',
			path: 'edit-massive-upload',
			meta: {
				title: 'PRODUCTOS EDICIÓN MASIVA',
			},
			component: () => import('@/components/products/massive-edit-upload'),
		},
		{
			name: 'products-history',
			path: 'history',
			meta: {
				title: 'LISTA DE INGRESOS',
			},
			component: () => import('@/components/products/history'),
		},
		{
			name: 'products-dispatch',
			path: 'dispatch',
			meta: {
				title: 'DESPACHO DE PRODUCTOS',
			},
			component: () => import('@/components/products/products-dispatch'),
		},
		{
			name: 'dispatch-detail',
			path: 'dispatch/:id/detail',
			meta: {
				title: 'PRODUCTOS POR ENTREGAR',
			},
			props: true,
			component: () => import('@/components/products/dispatch-detail'),
		},
		{
			name: 'min-stock',
			path: 'warehouse/:id/min-stock',
			meta: {
				title: 'PRODUCTOS CON STOCK MÍNIMO POR ALMACÉN',
			},
			props: true,
			component: () => import('@/components/products/min-stock'),
		},
		{
			name: 'sale-create',
			path: '/transfers/:id/new-sale',
			meta: {
				title: 'NUEVA VENTA DE TRANSFERENCIA',
			},
			props: true,
			component: () => import('@/components/products/sale-create'),
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/products.js